/* eslint-disable react/prop-types */

import { gql, useSubscription } from "@apollo/client";
import { createContext, useEffect, useState } from "react";
import { cerrarSesionArchivos } from "services/fileSession";

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [openNewLogin, setOpenNewLogin] = useState(null);
  const [dataLogin, setDataLogin] = useState(null);

  const { data: newLoginData } = useSubscription(
    gql`
      subscription newLogin {
        newLogin {
          navegador
          sistemaOperativo
          versionSistemaOperativo
          dispositivo
          ciudad
          pais
        }
      }
    `,
    {
      skip: !user,
    }
  );

  const handleUser = (user) => {
    if (user) {
      setUser(user);
    } else {
      setUser(null);
    }
  };

  const logout = () => {
    const tipoUser = user?.tipoUser;
    setUser(null);
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    cerrarSesionArchivos();
    window.location.href = tipoUser === "Proveedor" ? "/proveedores" : "/login";
  };

  const getToken = () => {
    if (localStorage.getItem("user")) {
      return JSON.parse(localStorage.getItem("user")).token;
    }
  };

  const verificarAcceso = (id, operation) => {
    if (user?.tipoUser === "Administrador") return true;
    const permissionIds = new Set((user?.permisos ?? []).map((permiso) => String(permiso.id)));
    const requiredIds = (Array.isArray(id) ? id : [id]).map((item) => String(item));
    return operation === "or"
      ? requiredIds.some((item) => permissionIds.has(item))
      : requiredIds.every((item) => permissionIds.has(item));
  };

  const data = { user, handleUser, getToken, logout, verificarAcceso, openNewLogin, dataLogin };

  useEffect(() => {
    console.log(newLoginData)
    if (newLoginData?.newLogin) {
      setOpenNewLogin(new Date().getTime());
      setDataLogin(newLoginData.newLogin);
    }
  }, [newLoginData]);

  return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
};

export { UserContext, UserProvider };
